/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Status_MatchedInputs */

const cs_pm_status_matched = /** @type {(inputs: Pm_Status_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spárováno`)
};

const en_pm_status_matched = /** @type {(inputs: Pm_Status_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

/**
* | output |
* | --- |
* | "Matched" |
*
* @param {Pm_Status_MatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_status_matched = /** @type {((inputs?: Pm_Status_MatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Status_MatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_status_matched(inputs)
	return cs_pm_status_matched(inputs)
});